import React from 'react';

const SUGGESTIONS = [
  { emoji: '📋', label: 'PV réunion',       texte: "Génère le PV de la réunion d'aujourd'hui" },
  { emoji: '✉️', label: 'Convocation AG',   texte: "Crée une convocation pour l'assemblée générale" },
  { emoji: '📬', label: 'Courrier bailleur',texte: 'Rédige un courrier de réclamation au bailleur 3F' },
  { emoji: '💶', label: 'Cotisations',       texte: "Qui n'a pas payé sa cotisation cette année ?" },
  { emoji: '📝', label: 'Compte rendu',      texte: 'Génère un compte rendu de réunion' },
  { emoji: '📊', label: 'Finances',          texte: "Montre le bilan financier de l'association" },
  { emoji: '⚠️', label: 'Mise en demeure',  texte: 'Rédige une mise en demeure pour les encombrants' },
];

export default function Suggestions({ onSelect }) {
  return (
    <div style={styles.bar}>
      {SUGGESTIONS.map((s, i) => (
        <button key={i} style={styles.chip} onClick={() => onSelect(s.texte)}>
          {s.emoji} {s.label}
        </button>
      ))}
    </div>
  );
}

const styles = {
  bar: {
    background: '#f7f7f7',
    borderBottom: '1px solid #e8e8e8',
    padding: '.55rem .8rem',
    display: 'flex',
    gap: '.45rem',
    overflowX: 'auto',
    flexShrink: 0,
    scrollbarWidth: 'none',
  },
  chip: {
    whiteSpace: 'nowrap',
    padding: '.35rem .75rem',
    background: '#fff',
    border: '1.5px solid #1a3a5c',
    borderRadius: 20,
    fontSize: '.72rem',
    fontWeight: 500,
    color: '#1a3a5c',
    cursor: 'pointer',
    fontFamily: 'Inter, sans-serif',
    flexShrink: 0,
    transition: 'all .15s',
  },
};
